export default __webpack_public_path__ + "static/media/actividad-1.2d2c8f38.mp3";